import { render, staticRenderFns } from "./codeBindBuy.vue?vue&type=template&id=4fdfcf6e&scoped=true"
import script from "./codeBindBuy.vue?vue&type=script&lang=js"
export * from "./codeBindBuy.vue?vue&type=script&lang=js"
import style0 from "./codeBindBuy.vue?vue&type=style&index=0&id=4fdfcf6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfcf6e",
  null
  
)

export default component.exports